import React from 'react';
import ChatSidePanel from './ChatSidePanel';
import ErrorBoundary from '../../../shared/ErrorBoundary';
import { useChatContext } from '../../../context/ChatContext';

const ChatPanel = () => {
    const { chatState, closeChat } = useChatContext();

    if (!chatState.open) return null;

    return (
        <>
            {/* Backdrop for mobile */}
            <div
                className="fixed inset-0 bg-black/40 z-40 sm:hidden"
                onClick={closeChat}
            />
            <div
                className="fixed right-0 top-0 z-50 bg-white flex flex-col"
                style={{
                    width: '100%',
                    maxWidth: '550px',
                    height: '100dvh',
                    boxShadow: '-4px 0 24px rgba(0,0,0,0.18)',
                    borderLeft: '1px solid #e5e7eb',
                }}
            >
                <ErrorBoundary
                    label="chat"
                    resetKey={chatState.data?.creative_id}
                    title="Chat failed to load"
                >
                    <ChatSidePanel data={chatState.data} onClose={closeChat} />
                </ErrorBoundary>
            </div>
        </>
    );
};

export default ChatPanel;
